import React from "react";
import { connect } from "react-redux";
import { DatePicker, Space } from 'antd';
import { getOutboundLogs } from "../../../actions/index";


import loader from '../../../assets/images/loader.gif'
import 'antd/dist/antd.css';
import './outboundSearch.css';
import history from "../../../history";



const { RangePicker } = DatePicker;


export class OutboundSearch extends React.Component {

    constructor(props) {
        super(props);
        this.searchBox = React.createRef();
        this.searchButton = React.createRef();
        this.recipientEmailInput = React.createRef();
        this.logsLimitInput = React.createRef();
        this.state = {
            showError: false,
            errorMessage: "",
            dateMoment: [],
            dateString: [],
            recipientEmail: "",
            logsLimit: "200"
        }

    }

    componentDidMount() {
        if ((this.props.logTerm && this.props.logType === 'outbound') && !(this.props.logs && this.props.logs.length) ) {
            this.searchBox.current.value = this.props.logTerm
            this.getInfo()
        }
    }
    handleKeyPressOnInput = (e) => {

        if (e.key === 'Enter') {
            this.getInfo()
        }
    }

    getInfo = () => {
        this.searchButton.current.disabled = true
        this.searchButton.current.innerHTML = `<img src=${loader} alt='loader' width="30%" />`

        let searchTerm = this.searchBox.current.value ? this.searchBox.current.value.trim() : this.props.searchTerm ? this.props.searchTerm.trim() : ''

        if (searchTerm.match(/^[0-9]+$/) !== null || searchTerm.toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gi
      )) {
            history.push(`/log/outbound/${searchTerm}`)
            // if (!this.state.dateString.length) {
            //     this.searchButton.current.disabled = false
            //     this.searchButton.current.innerHTML = "Get Info"
            //     this.setState({ errorMessage: 'Select a valid start and end date', showError: 'true' })
            //     return;
            // }
            if (this.recipientEmailInput.current.value.trim().length && !this.recipientEmailInput.current.value.trim().toLowerCase()
                .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gi)) {
                this.searchButton.current.disabled = false
                this.searchButton.current.innerHTML = "Get Info"
                
                this.recipientEmailInput.current.style.borderColor = "red"
                this.setState({ errorMessage: 'Enter a valid email address in filter', showError: 'true' })
                return;
            }
            console.log(this.state.dateString)
            
            this.props.getOutboundLogs(searchTerm, this.state.dateString, this.state.logsLimit, this.state.recipientEmail)
                .then((response) => {
                    this.searchButton.current.disabled = false
                    this.searchButton.current.innerHTML = "Get Info"
                    this.recipientEmailInput.current.style.borderColor = null

                    if (response === 'success') {

                        if (!this.props.logs) {
                            console.log('No Results found')
                            this.setState({ errorMessage: 'No Results Found!', showError: true })
                        } else {
                            console.log('Outbound Log Search Results')
                            this.setState({ errorMessage: '', showError: false })
                            console.log(this.props.logs.length)
                            console.log(this.props.logs[0])
                        }
                    } else {
                        console.log('An error occurred while performing this operation')
                        this.recipientEmailInput.current.style.borderColor = null
                        this.setState({ errorMessage: 'An error occurred while performing this operation', showError: true })
                    }
                })

        } else {
            this.searchButton.current.disabled = false
            this.searchButton.current.innerHTML = "Get Info"
            this.recipientEmailInput.current.style.borderColor = null
            this.setState({ errorMessage: 'Enter a valid Campaign ID / Registered Email address', showError: 'true' })

        }

    }






    render() {
        return (
            <React.Fragment>
                <div className="OutboundSearch-box">
                    <div className="OutboundSearch-input">
                        <input type='text' id="OutboundSearch" placeholder="Enter Campaign ID / Sender Email Address" onKeyDown={this.handleKeyPressOnInput} ref={this.searchBox} defaultValue={this.props.searchTerm ? this.props.searchTerm : this.props.search ? this.props.search : ''}></input>
                        <div className={`OutboundSearch-Error ${this.state.showError ? 'show' : 'hidden'}`} >{this.state.errorMessage}</div>
                    </div>
                    <button id="campaignButton" ref={this.searchButton} onClick={this.getInfo}> Get Info</button>
                    <div className="OutboundSearch-date">
                        <Space direction="horizontal" size={11}>
                            <RangePicker onChange={(dateMoment, dateString) => {
                                if (dateString.length && dateString[0].length) {
                 
                                    this.setState({
                                        dateMoment, dateString: [dateString[0], //Moving endDate by 1 day
                                        new Date(Date.parse(dateString[1]) + 86400000).toISOString().substring(0, 10)]
                                    })
                                } else {
                                    this.setState({
                                        dateMoment: [],
                                        dateString: []
                                    })
                                }
                            }}
                                value={this.state.dateMoment ? this.state.dateMoment : []} />
                        </Space>
                    </div>
                </div>
                <div className="OutboundSearch-filters">
                    <div className="OutboundSearch-filters-heading">Filters</div>
                    <div className="OutboundSearch-filters-search">
                        <h4>Search Last</h4>
                        <select name="logsLimit" id="logsLimit" ref={this.logsLimitInput} value={this.state.logsLimit ? this.state.logsLimit : '200'}
                            onChange={(e) => { this.setState({ logsLimit: e.target.value }) }}
                        >
                            <option value="200">200 Logs</option>
                            <option value="500">500 Logs</option>
                            <option value="1000">1000 Logs</option>
                        </select>
                    </div>
                    <div className="OutboundSearch-filters-recipientEmail">
                        <h4>Email</h4>
                        <input type="email" id="recipientEmail" name="email" placeholder="Filter Based On Email" ref={this.recipientEmailInput} autoComplete="off"
                            value={this.state.recipientEmail ? this.state.recipientEmail : ''} onChange={(e) => { this.setState({ recipientEmail: e.target.value }) }} />
                    </div>

                </div>


            </React.Fragment>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        logs: state.logs.outboundLogs.logs, searchTerm: state.logs.outboundLogs.searchTerm
    };
};

export default connect(mapStateToProps, { getOutboundLogs })(OutboundSearch);
